/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface NotificationReadPutParams {
  guid: string;
}

export function notificationReadPut(
  http: HttpClient,
  rootUrl: string,
  params: NotificationReadPutParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, notificationReadPut.PATH, 'put');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.path('guid', params.guid, { style: 'simple' });

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<void>;
      }),
    );
}

notificationReadPut.PATH = '/api/v1/notifications/{guid}/read';
